import { createContext } from '@chakra-ui/react-utils';

import type { TableContainerProps } from '../components/TableContainer';

export type TableContextValue = Pick<
  TableContainerProps,
  'size' | 'variant' | 'zebra' | 'density'
>;

const [TableProvider, useTableContext] = createContext<TableContextValue>({
  name: 'TableV2Context',
  errorMessage:
    'useTableV2Context: `context` is undefined. Seems you used a TableV2 sub-component that required context outside of a TableV2 wrapping box.',
  strict: false,
});

export { TableProvider, useTableContext };
